<ng-sidebar-container>
  <div ng-sidebar-content>
    <ngx-page-container>
      <h1>Nippon Rika Navigation Center</h1>
      <hr>
      <!-- <div class="row" style="position:relative;top:-4em;left:20em;margin-bottom:-4em" *ngIf="user"> -->

      <div><button class='nrk-button' (click)="reload()">Refresh data <i class="ion-refresh"></i></button></div>
      <hr>
      <div class="row" *ngIf="auth.user">

        <div style="margin-left:1em;min-width:35em" *ngIf="search">
          <label><b>Filter</b></label>
          <div class="row ml-1">
            <div>
              <!-- <ngx-form-dropdown title="Issuer" [(value)]="search.customeroverview.issuer" [options]="issuerOptions"></ngx-form-dropdown>
              <ngx-doc-form-filter-select title="Country"  noBorder="true" [(value)]="search.customeroverview.country" [options]="countryOptions"></ngx-doc-form-filter-select> -->
              <!-- <ng-select [multiple]="true" [(ngModel)]="filter.issuers" placeholder="Select issuer(s)">
                <ng-option *ngFor="let option of issuerOptions" [value]="option.id">{{option.name}}</ng-option>
              </ng-select> -->
              <ngx-doc-form-multiselect [(value)]="filter.issuers" [options]="issuerOptions" [checkbox]="true" placeholder="Select issuer(s)"></ngx-doc-form-multiselect>
              <!-- <ng-select [(ngModel)]="filter.country" placeholder="Select country">
                <ng-option *ngFor="let option of countryOptions" [value]="option.id">{{option.name}}</ng-option>
              </ng-select> -->
              <ngx-doc-form-multiselect [(value)]="filter.country" [options]="countryOptions" placeholder="Select country"></ngx-doc-form-multiselect>
            </div>
            <div style="width: 42em">
              <ngx-doc-form-multiselect [(value)]="filter.customers" [options]="data.businessOptions" (valueChange)="customersChanged($event)"
                [checkbox]="true" [maxSelectedItems]="3" placeholder="Select customer(s)">
              </ngx-doc-form-multiselect>
              <ngx-doc-form-multiselect *ngIf="filter.customers?.length" [(value)]="filter.customerDocumentNumbers" [checkbox]="true"
                [options]="customerReferenceOptions" placeholder="Customer reference(s)">
              </ngx-doc-form-multiselect>
              <!-- <ngx-doc-form-multiselect *ngIf="filter.customers?.length" [(value)]="filter.finishedProducts" [items]="finishedProductOptions"
                [checkbox]="true" placeholder="Finished product(s)">
              </ngx-doc-form-multiselect> -->

              <ngx-doc-form-multiselect *ngIf="filter.businessUnits" [(value)]="filter.businessUnits" [options]="data.businessUnitOptions"
                [checkbox]="true" placeholder="Select business unit(s)">
              </ngx-doc-form-multiselect>
            </div>
          </div>

          <div class="mt-4" style="max-width:57em">
            <ngx-form-multi-select [checkbox]="true" title="Select Finished products" [businessId]="finishedProductBusinessId" [mode]="'column-select'" [(value)]="filter.finishedProducts" [options]="data.finishedProductOptions">
            </ngx-form-multi-select>
          </div>

          <!-- <div class="row ml-2 mt-3">
            <div>Sample Requests:</div>
            <div class="ml-3"><input name="filterSR" type="radio" [(ngModel)]="filter.sampleRequest" [value]="0" /><label class="ml-2">Predefined</label></div>
            <div class="ml-3"><input name="filterSR" type="radio" [(ngModel)]="filter.sampleRequest" [value]="1" /><label class="ml-2">All</label></div>
            <div class="ml-3"><input name="filterSR" type="radio" [(ngModel)]="filter.sampleRequest" [value]="2" /><label class="ml-2">SR</label></div>
            <div class="ml-3"><input name="filterSR" type="radio" [(ngModel)]="filter.sampleRequest" [value]="3" /><label class="ml-2">No SR</label></div>
          </div> -->

          <div>
            <!-- <button class="nrk-button m-1" (click)="reload()" [attr.disabled]="loading ? true : null">apply filters</button> -->
            <button *ngIf="filter.customers.length > 0" class="nrk-button m-1" (click)="downloadPdf()" [attr.disabled]="loading ? true : null">create PDF</button>
            <button *ngIf="filter.customers.length > 0" class="nrk-button m-1" (click)="downloadPdf(false)" [attr.disabled]="loading ? true : null">create PDF W/O overview</button>
            <button *ngIf="filter.customers.length === 1 && filter.finishedProducts.length === 1" class="nrk-button m-2" (click)="showPfspoSelection()">PFSPO availability</button>
          </div>

          <div>
            <button class="nrk-button m-1" (click)="showReportsSelection=!showReportsSelection">select reports</button>
            <div *ngIf="showReportsSelection">
              <div class="row ml-3 my-2"><div class="col-md-6"></div><button class="nrk-button" (click)="toggleShowAllReports()">toggle show all reports</button></div>
              <ng-container *ngFor="let report of filter.attachedReports | keyvalue">
                <ng-container *ngTemplateOutlet="coreport; context: { $implicit: report }"></ng-container>
              </ng-container>
            </div>
          </div>
        </div>

        <div style="margin-left:2em">
          <label><b>Selection</b></label>
          <div>
            <input name="dashboardtype" type="radio" [(ngModel)]="auth.user.erpRoles.dashboardType" [value]="1"
              [attr.disabled]="loading ? true : null">
            <label style="margin-left:0.7em;">My Business overview</label>
          </div>
          <div>
            <input name="dashboardtype" type="radio" [(ngModel)]="auth.user.erpRoles.dashboardType" [value]="2"
              [attr.disabled]="loading ? true : null">
            <label style="margin-left:0.7em;">NRK Europe Business overview</label>
          </div>
          <div>
            <label><b>Date selection</b></label>
            <table><tr><td style="padding-right:2em">
                <div>
                  <input name="dateSelection" type="radio" [(ngModel)]="dateSelection" [value]="1"
                    [attr.disabled]="loading ? true : null">
                  <label style="margin-left:0.7em;">Default</label>
                </div>
                <div>
                  <input name="dateSelection" type="radio" [(ngModel)]="dateSelection" [value]="5"
                    [attr.disabled]="loading ? true : null">
                  <label style="margin-left:0.7em;">YTD</label>
                </div>
                <div>
                  <input name="dateSelection" type="radio" [(ngModel)]="dateSelection" [value]="2"
                    [attr.disabled]="loading ? true : null">
                  <label style="margin-left:0.7em;">year</label>
                </div>
              </td><td>
                <div>
                  <input name="dateSelection" type="radio" [(ngModel)]="dateSelection" [value]="4"
                    [attr.disabled]="loading ? true : null">
                  <label style="margin-left:0.7em;">last 12 months</label>
                </div>
                <div>
                  <input name="dateSelection" type="radio" [(ngModel)]="dateSelection" [value]="3"
                    [attr.disabled]="loading ? true : null">
                  <label style="margin-left:0.7em;">current month</label>
                </div>
                <div>
                  <input name="dateSelection" type="radio" [(ngModel)]="dateSelection" [value]="6"
                    [attr.disabled]="loading ? true : null">
                  <label style="margin-left:0.7em;">business week</label>
                </div>
              </td></tr>
            </table>
          </div>
        </div>

        <div style="margin-left:1em">
          <label><b>Succession</b></label>
          <div>
            <input name="sortorder" type="radio" [(ngModel)]="searchsort" [value]="1" [attr.disabled]="loading ? true : null"/>
            <label style="margin-left:0.7em;">IN - Due IN - OR - NOC - PFIN - NOC(SR) - OF</label>
          </div>
          <div>
            <input name="sortorder" type="radio" [(ngModel)]="searchsort" [value]="2" [attr.disabled]="loading ? true : null" />
            <label style="margin-left:0.7em;">OF - NOC - NOC(SR) - Due IN - OR - IN - PFIN</label>
          </div>

          <label><b>Markup</b></label>
          <!-- <ngx-doc-form-checkbox 
            class="fullwidth" 
            label="Show (PF)SPOs / Markup"  
            [value]="filter.relatedSPOs == 2" 
            (valueChange)="changeMarkup($event)">
          </ngx-doc-form-checkbox> -->
          <div>
            <input name="markupSelect" type="radio" [(ngModel)]="markupSelection" (ngModelChange)="markupChanged($event)" [value]="1" [attr.disabled]="loading ? true : null" />
            <label style="margin-left:0.7em;">Don't show (PF)SPO / Markup</label>
          </div>
          <div>
            <input name="markupSelect" type="radio" [(ngModel)]="markupSelection" (ngModelChange)="markupChanged($event)" [value]="2" [attr.disabled]="loading ? true : null" />
            <label style="margin-left:0.7em;">Show (PF)SPO</label>
          </div>
          <div>
            <input name="markupSelect" type="radio" [(ngModel)]="markupSelection" (ngModelChange)="markupChanged($event)" [value]="3" [attr.disabled]="loading ? true : null" />
            <label style="margin-left:0.7em;">Show Markup</label>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button class="btn btn-info btn-md" (click)="reload()" [attr.disabled]="loading ? true : null">apply filters</button>
      </div>

      <hr>

      <ngx-loading-spinner [loading]="loading"></ngx-loading-spinner>

      <ngx-dashboard-renderer [search]="search" (done)="loaded()"></ngx-dashboard-renderer>

      <br />
      <br />
      <br />
      <br />
      <br />

      <div class="sidebar footer text-center position-fixed">
        <button class="btn btn-default btn-lg" (click)="onClose()">Close</button>
      </div>
    </ngx-page-container>
  </div>
</ng-sidebar-container>

<div *ngIf="search && filter.customers.length && triggerPdfDownload" style="display: none">
  <ngx-customer-printer #customerPrinter [search]="search" [pdfSidebar]="true" (done)="pdfDataLoaded()"></ngx-customer-printer>
</div>

<ng-template #coreport let-report>
  <div class="row">
    <div class="col-md-6">{{report.value.text}}</div>
    <div class="checkbox col-md-6">
      <input type="checkbox" [(ngModel)]="report.value.show" />
      <label class="ml-1">Number of documents:</label>
      <input class="ml-1" style="width:3em" type="text" [(ngModel)]="report.value.limit" [attr.disabled]="report.value.showAll ? true : null"/>
      <input type="checkbox" class="ml-3" [(ngModel)]="report.value.showAll" />
      <label class="ml-1">All</label>
    </div>
  </div>
</ng-template>


